<template>
      <a-row>
        <a-col :span="10">
          <a-form-item :labelCol="labelCol3" :wrapperCol="wrapperCol3" label="采购物品" >
            <a-select
              placeholder="请选择采购物品"
              showSearch
              optionFilterProp="children"
              v-decorator="[
                `inquiryProductId[${item}]`,
                {
                  initialValue: arr[item] ? arr[item].inquiryProductId : undefined,
                  rules: [{ required: true, message: '请选择采购物品' }],
                },
              ]"
              :disabled="!isEdit"
            >
              <a-select-option v-for="(option, index) in InquiryList" :key="index" :value="option.id">
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购数量">
            <a-input
              placeholder="请输入采购数量"
              v-decorator="[
                `num[${item}]`,
                {
                  initialValue: arr[item] ? arr[item].num : undefined,
                  rules: [{ required: true, message: '请输入采购数量！' }],
                },
              ]"
              @change="onChangeNum"
              :disabled="!isEdit"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="2">
          <a-form-item>
            <a-select
              placeholder="单位"
              showSearch
              optionFilterProp="children"
              v-decorator="[
                `unit[${item}]`,
                {
                  initialValue: arr[item] ? arr[item].unit : undefined,
                  rules: [{ required: true, message: '请选择单位！' }],
                },
              ]"
              :disabled="!isEdit"
            >
              <a-select-option v-for="(option, index) in UnitList" :key="index" :value="option.code">
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="采购单价" :extra="`总价：${totalPrice}元`">
            <a-input
              placeholder="请输入采购单价"
              v-decorator="[
                `price[${item}]`,
                {
                  initialValue: arr[item] ? arr[item].price : undefined,
                  rules: [{ required: true, message: '请输入采购单价！' }],
                },
              ]"
              @change="onChangePrice"
              :disabled="!isEdit"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="2">
          <a-form-item style="float: right; margin-right: 32px">
            <a-button @click="removeRow(item)" :disabled="!isEdit">删除</a-button>
          </a-form-item>
        </a-col>
      </a-row>
</template>

<script>
export default {
  props: {
    arr: {
      type: Array,
      default: function () {
        return []
      },
    },
    item:[Number],
    InquiryList: [Array],
    UnitList: [Array],
    form: [Object],
    type: [String],
    isAdd:[Boolean]
  },
  data() {
    return {
      id: 0,
      keysList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      colSpan: 6,
      totalPrice:0
    }
  },
  computed: {
    isEdit() {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
  },
  created() {
    if(this.type !== this.$sysInfo.MODAL_VIEW){
        if(!this.isAdd){
        this.totalPrice = Number(this.arr[this.item].num) * Number(this.arr[this.item].price)
        }
    }
  },
  methods: {
    // 移除某行
    removeRow(k) {
      this.$emit('removeRow',k)
    },
    // 删除最后一项清空
    clear(item) {
      let inquiryProductIdArr = this.form.getFieldValue('inquiryProductId')
      inquiryProductIdArr[item] = ''
      let numArr = this.form.getFieldValue('num')
      numArr[item] = ''
      let unitArr = this.form.getFieldValue('unit')
      unitArr[item] = ''
      let priceArr = this.form.getFieldValue('price')
      priceArr[item] = ''
      this.form.setFieldsValue({
        inquiryProductId: inquiryProductIdArr,
        num: numArr,
        unit: unitArr,
        price: priceArr,
      })
    },
    onChangeNum(e){
        let num = Number(e.target.value)
        let price = Number(this.form.getFieldValue('price')[this.item])
        if(isNaN(num) || num < 0){
            num = 0
        }
        if(isNaN(price) || price < 0){
            price = 0
        }
        this.totalPrice = num * price
    },
    onChangePrice(e){
        let num = Number(this.form.getFieldValue('num')[this.item])
        let price = Number(e.target.value)
        if(isNaN(num) || num < 0){
            num = 0
        }
        if(isNaN(price) || price < 0){
            price = 0
        }
        this.totalPrice = num * price
    },
    initTotalPrice(data){
      this.totalPrice = data
    }
  },
  
}
</script>

<style lang="less" scoped>
</style>

